import React, { useState, useEffect } from 'react'
import Image from '../../../baseComponents/Image'
// import FeaturedProduct from './FeaturedProduct'
import CustomSelect from '../../PharmacoVigilance/components/FormComponents/CustomSelect'

import arrow from '../../../assets/images/svg_icons/arrow.svg'
import close from '../../../assets/images/svg_icons/close.svg'
import { connect } from 'react-redux'

import { langTexts } from '../locals'

const Products = props => {
  const [selectedProduct, setSelectedProduct] = useState('')
    , [currentProductList, setCurrentProductList] = useState(null)
    , [currentProduct, setCurrentProduct] = useState(null)
    , { lang, /* featuredProduct*/ texts } = props

  const onProducSelect = product => {
    setSelectedProduct(product)
    setCurrentProductList(list[product])
    setCurrentProduct(null)
  }

  let { list, brands } = props.products

  let productList = Object.keys(list)
    .sort((a, b) => {
      if (a < b) return -1
      if (a > b) return 1
      return 0
    })
    .filter(key => {
      let products = list[key].filter(product => typeof product.link === 'string' && product.link.length !== 0)
      return products.length
    })

  useEffect(() => {
    let key = productList[0]
    if (key) {
      setSelectedProduct(key)
      setCurrentProductList(list[key])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])


  let text = langTexts[lang]
    , brand = brands[selectedProduct] ? brands[selectedProduct][0] : null

  return <div className='products__product-container transition'>
    {/* <FeaturedProduct data={featuredProduct} onClick={product => {
      setSelectedProduct(product)
      setCurrentProductList(list[product])
      setCurrentProduct(null)
    }} /> */}
    <div className='products__product-main'>
      <CustomSelect
        className='products__product-list-select'
        label={texts['selectProductTag']}
        options={productList}
        onChange={onProducSelect}
      />
      <div className='products__product-list'>
        {
          productList.map(product => <div
            onClick={() => {
              setSelectedProduct(product)
              setCurrentProductList(list[product])
              setCurrentProduct(null)
            }}
            className={`products__product-list-item gray-color ${product === selectedProduct ? 'active' : ''}`}
            key={product}>{product}</div>)
        }
      </div>
      <div className='products__pruducts-grid'>
        {
          currentProduct &&
          <div className='products__modal'>
            <div className='products__modal-container'>
              {
                Boolean(currentProduct.gallery && currentProduct.gallery.length)
                  ? <Image className='products__product-image modal-image' src={currentProduct.gallery[0]} fromCMS={true} />
                  : <div className='products__product-image modal-image' style={{ background: 'red' }} />
              }
              <div className='products__modal-block'>
                <div className='products__modal-info'>
                  <h2>{currentProduct.nmDroga}</h2>
                  <div className='gray-color'>
                    <p>
                      <b>{text.nmDroga}</b>: {currentProduct.nmDroga}
                    </p>
                    <p>
                      <b>{text.prncpioActvReg}</b>: {currentProduct.prncpioActvReg}
                    </p>
                  </div>
                </div>
                <div className='products__modal-buyBtn'>
                  {
                    typeof currentProduct.link === 'string' &&
                    Boolean(currentProduct.link.length) &&
                    <a href={currentProduct.link} target='_blank' rel='noopener noreferrer'>
                      {texts.buyBtn}
                      <img className='arrow-left' src={arrow} alt='flecha' />
                    </a>
                  }
                </div>
              </div>
              <span className='close-btn' onClick={() => setCurrentProduct(null)}>
                <img src={close} alt='cerrar' className='arrow-left' />
              </span>
            </div>
          </div>
        }
        <div className='products__product-content'>
          {
            currentProductList &&
            <React.Fragment>
              <div className='products_product-info'>
                {
                  Boolean(brand)
                    ? <div className='products__brand'>
                      <img src={brand.logo_url} alt={selectedProduct} />
                      {
                        brand.web &&
                        <a className='btn' href={brand.web} target='_blank' rel='noopener noreferrer'>{texts.visitWeb}</a>
                      }
                    </div>
                    : <h2 className='products__brand-title'>{selectedProduct}</h2>
                }
              </div>
              <div className='products__products-container'>
                {
                  currentProductList
                    .filter(product => typeof product.link === 'string' && product.link.length !== 0)
                    .map((product, index) => {
                      return <div key={index} className='products__products-item'>
                        {
                          Boolean(product.gallery && product.gallery.length) &&
                          <Image onClick={() => setCurrentProduct(product)} className='products__product-image' src={product.gallery[0]} fromCMS={true} />
                        }
                        <p className='products__products-item-name'>{product.nmDroga}</p>
                        <div>
                        </div>
                      </div>
                    })
                }
              </div>
            </React.Fragment>
          }
        </div>
        <div className='go_up'>
          <a href='#top'>{texts.goUp}</a>
          <img className='arrow-left' src={arrow} alt='arrow' />
        </div>
      </div>
    </div>
  </div>
}

const mapStateToPros = state => ({
  products: state.products,
  settings: state.settings
})

export default connect(mapStateToPros)(Products)
